import { createSelector } from 'reselect';
import { playerStatsSelector } from './simple-selectors';

export const playerStatsNavSelector = createSelector(
    playerStatsSelector,
    (playerStats) => playerStats.nav
);
